import EmberService, { service } from '@ember/service';

import type { APIData, Service } from 'webapp-types';
import { TourId } from 'webapp/enums/tour';

import AccountWhiteLabelingPromoPopupComponent from 'webapp/components/account/white-labeling/popup-promo';

// Promote WL add-on: Paying Customers
// https://app.asana.com/0/527984279702626/1203078568982368/f

export default class FlowWhiteLabelingPayingCustomersPromoService extends EmberService {
	@service('popup') declare popupService: Service.Popup;
	@service('request') declare requestService: Service.Request;
	@service('tour') declare tourService: Service.Tour;

	private openWhiteLabelingPromoPopup(
		data: APIData.Account.WhiteLabelingPayingCustomersPromoCompany,
	): void {
		this.popupService
			.createModal(AccountWhiteLabelingPromoPopupComponent, {
				popupClass: 'popup-type-account-whitelabeling-promo',
				showClose: false,
			})
			.open({ company: data });
	}

	private checkIfComingFromEmail(): boolean {
		const searchParams = new URLSearchParams(window.location.search);

		return searchParams.get('utm_content') === 'start_white_labeling';
	}

	checkToOpenPopup(): void {
		if (this.popupService.anyPopupsOpen) {
			return;
		}

		if (!this.tourService.isEligibleForWhitelabelingPayingCustomersPromoTour) {
			return;
		}

		if (this.checkIfComingFromEmail()) {
			this.tourService.initTour(TourId.WHITE_LABELING_PAYING_CUSTOMERS_PROMO)?.markDone();
			return;
		}

		this.requestService
			.api<APIData.Account.WhiteLabelingPayingCustomersPromoResponse>(
				'POST',
				'/account/wl-promo-popup',
			)
			.then((response) => {
				const { showPopup, company } = response;

				if (showPopup) {
					this.openWhiteLabelingPromoPopup(company);
				}
			})
			.catch(this.requestService.showAllValidationErrors.bind(this.requestService));
	}
}

declare module '@ember/service' {
	interface Registry {
		'flow/white-labeling-paying-customers-promo': FlowWhiteLabelingPayingCustomersPromoService;
	}
}
